import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/action-plans')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_layout/_teacher-portal/action-plans"!</div>
}
